import { useQuery } from '@tanstack/react-query';
import { companiesService } from '../services/companies.service';
import type { GetAllCompaniesApiRequest } from '@momentum/types';

export const companyKeys = {
  all: ['companies'] as const,
  list: (params?: GetAllCompaniesApiRequest) =>
    [...companyKeys.all, 'list', params] as const,
};

// Get all companies – system admin only (enforced by backend)
export const useCompanies = (
  params: GetAllCompaniesApiRequest = {},
  enabled = true
) => {
  return useQuery({
    queryKey: companyKeys.list(params),
    queryFn: () => companiesService.getAllCompanies(params),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
